export const translate = ( key, defaultValue = '') => {
    let text = window.jsTranslations[key];
    return text ? text : defaultValue;
}